import { render, staticRenderFns } from "./SibebarExtra.vue?vue&type=template&id=6cce63a6&"
import script from "./SibebarExtra.vue?vue&type=script&lang=js&"
export * from "./SibebarExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports